import type { Category } from './categories';

export type Cell = Category | 'free';

export interface Card {
  cells: Cell[]; // length 25
}

export const FREE_INDEX = 12;

const rows = [0, 1, 2, 3, 4].map((r) => [0, 1, 2, 3, 4].map((c) => r * 5 + c));
const cols = [0, 1, 2, 3, 4].map((c) => [0, 1, 2, 3, 4].map((r) => r * 5 + c));
const diags = [
  [0, 6, 12, 18, 24],
  [4, 8, 12, 16, 20],
];

export const LINES: readonly number[][] = [...rows, ...cols, ...diags];
